export default "__VITE_ASSET__1_lXfZyt__"